<template>
  <header>
    <div
      class="w-full bg-white shadow-2xl p-4 lg:p-0 lg:flex justify-center items-center"
    >
      <div
        class="flex flex-col justify-between w-full max-w-screen-xl lg:flex-row"
      >
        <div class="w-full flex justify-between">
          <div class="flex items-center justify-center lg:ml-4">
            <img
              src="@/assets/AddifyLogo_Transparent.png"
              alt="GetAddify Logo"
              class="h-8"
            />
          </div>
          <div
            class="flex flex-col items-center justify-center w-10 h-10 rounded-lg bg-lula-light cursor-pointer border border-transparent hover:border-lula transition hover:border-lula lg:hidden"
            :class="{ 'border-lula': open }"
            @click="open = !open"
          >
            <div
              class="h-0.5 my-0.5 bg-lula rounded-2xl transform transition-all"
              :class="{
                'rotate-45 translate-y-0.5 w-6/12': open,
                'w-9/12': !open,
              }"
            />
            <div
              class="h-0.5 w-9/12 my-0.5 bg-lula rounded-2xl"
              :class="{ hidden: open }"
            />
            <div
              class="h-0.5 my-0.5 bg-lula rounded-2xl transform transition-all"
              :class="{
                '-rotate-45 -translate-y-1 w-6/12': open,
                'w-9/12': !open,
              }"
            />
          </div>
        </div>
        <div
          class="transform pt-px lg:pt-0 lg:block"
          :class="{ hidden: !open }"
        >
          <ul class="text-gray-500 lg:flex">
            <li
              class="relative flex select-none cursor-pointer hover:text-lula transition lg:text-center"
              v-for="option in options"
              :key="option.name"
            >
              <a
                :href="option.redirect"
                class="w-full h-full lg:p-6 lg:m-0"
                v-if="option.redirect"
              >
                {{ option.name }}
              </a>
              <a
                :href="option.link"
                class="w-full h-full lg:p-6 lg:m-0"
                v-else-if="option.link"
              >
                {{ option.name }}
              </a>
              <router-link
                class="flex items-center w-max h-full lg:p-6 lg:m-0"
                @click="open = false"
                :to="{ name: option.route }"
                replace
                v-else
              >
                {{ option.name }}
              </router-link>
            </li>
            <li
              class="relative flex select-none cursor-pointer hover:text-lula transition lg:text-center"
            >
              <a
                class="w-full h-full lg:p-6 lg:m-0"
                @click="$store.dispatch('signOut')"
                href="#"
                >Logout</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { ref } from "vue";

export default {
  props: ["options"],
  setup() {
    return {
      open: ref(false),
    };
  },
};
</script>
